export { default } from './CardMedia';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CardMedia/index.js
// module id = 316
// module chunks = 0